import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ReactGA from 'react-ga';
import NavBar from './components/NavBar/NavBar';
import SEO from './components/SEO/SEO';
import Home from './pages/Home/Home';
import Skills from './pages/Skills/Skills';
import Footer from './components/Footer/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import Calculator from './pages/EstimatePage';
import HomeownersSignUp from './components/Auth/HomeownersSignUp';
import Login from './components/Auth/Login';
import Dashboard from './components/Dashboard';
import AuthenticationPage from './components/Auth/AuthenticationPage';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import Contact from './pages/Contact/Contact';
import FAQ from './pages/FAQ';
import Terms from './pages/Terms';
import Profile from './components/Profile';
import AuthProvider from './providers/AuthProvider';
import PrivateRoute from './components/PrivateRoute';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';

// Initialize Google Analytics if tracking ID is provided
if (process.env.REACT_APP_TRACKING_ID) {
  ReactGA.initialize(process.env.REACT_APP_TRACKING_ID);
  ReactGA.pageview(window.location.pathname + window.location.search);
}

function App() {
  useEffect(() => {
    const testBackend = async () => {
      try {
        const response = await fetch('https://xtreme-backend.onrender.com/api/health');
        const data = await response.json();
        console.log('Backend status:', data);
      } catch (error) {
        console.error('Backend test failed:', error);
      }
    };

    testBackend();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <SEO />
          <div className="App">
            <header>
              <NavBar />
            </header>
            <main className="main-content" role="main">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/calculator" element={<Calculator />} />
                <Route path="/website" element={<Home />} />
                <Route path="/skills" element={<Skills />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/homeowners-signup" element={<HomeownersSignUp />} />
                <Route path="/login" element={<Login />} />
                <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <PrivateRoute>
                      <Profile />
                    </PrivateRoute>
                  }
                />
                <Route path="/auth" element={<AuthenticationPage />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/terms" element={<Terms />} />
              </Routes>
            </main>
            <footer>
              <Footer />
            </footer>
          </div>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
